import PropTypes from 'prop-types';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteField, getAllFields } from '../../../actions/promotion/fields';
import { If } from 'react-if';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  Button,
  Input,
  Spinner,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { formatDate } from '../../../helpers/formatDate';
import { formatTime } from '../../../helpers/formatTime';
import { Link } from 'react-router-dom';
import AddConfigs from './AddConfig';
import AlertDelete from './AlertDelete';
import { alertError, alertSuccess } from '../../../helpers/errorHandling';
import { getAllConfigs } from '../../../actions/promotion/generals';
import { configTypes, configTypesList } from './constants';

// ==============================|| Field - LIST ||============================== //

const Configs = (...rest) => {
  const [data, setData] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [field, setField] = useState(null);
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({});
  const [pageOffset, setPageOffset] = useState(0);

  const [dropdownOpen, setDropdownOpen] = useState({});
  const [direction] = useState('down');

  const params = useParams();

  const getConfigs = async () => {
    setLoading(true);
    const { data, meta } = await getAllConfigs({
      configName: params.configName,
      configEnv: process.env.NODE_ENV,
      pageOffset: Math.max(pageOffset - 1, 0),
      pageSize: 100,
    });

    setTimeout(() => {
      setData(data);
      setMeta(meta);
      setLoading(false);
      console.log('data', data);
    }, 400);
  };

  useEffect(() => {
    getConfigs();
  }, [pageOffset, params.configName]);

  const handleAdd = (f) => {
    if (f?._id) {
      setField({ ...f });
    } else {
      setField(null);
    }
    // navigate('/configurations/fields/addfields/new');
    setAdd(!add);

    // when closing and there is data in field object it get cleared
  };

  const handleClose = () => {
    setDeleteOpen(!deleteOpen);
  };

  const deleteUserHandler = async (fieldDeleteId) => {
    const res = await deleteField({ fieldId: fieldDeleteId });
    if (res?.deleteField?.success) {
      alertSuccess('Field deleted successfully');
      getConfigs();
      handleClose(true);
    } else {
      alertError('Failed!. Please try again later..');
    }
  };

  const handleRefreshData = () => {
    getConfigs();
  };
  const handlePageOffset = (value) => {
    setPageOffset(value);
  };

  const toggleDropdown = (itemId) => {
    setDropdownOpen((prevState) => ({
      // ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };

  console.log(dropdownOpen);
  const [editField, setEditField] = useState();
  const [isOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setEditField(null);
    setModalOpen(!isOpen);
  };
  return (
    <div className="page-content px-4 pb-4">
      {/* <AddConfigs
                            configIdFromProps={field?._id}
                            configDetailFromProp={field ? { ...field } : null}
                            onCancel={handleAdd}
                            getConfigs={getConfigs}
                            configName={params.configName}
                       
                          /> */}
      <BreadCrumb titleInActive={'Admin'} titleActive="Configurations" />

      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">
              {configTypes?.[params.configName]?.label || ''}
            </h4>
            <Button
              size="sm"
              color="info"
              className="d-flex align-items-center gap-1"
              onClick={() => {
                toggleModal(true);
              }}
            >
              <i className="bx bx-plus"></i> Create new field
            </Button>
            <AddConfigs
              configIdFromProps={editField?._id}
              configDetailFromProp={editField ? { ...editField } : null}
              onCancel={handleAdd}
              getConfigs={getConfigs}
              configName={params.configName}
              isOpen={isOpen}
              toggleOpen={toggleModal}
            />
          </div>
          <table className="table table-nowrap table-centered align-middle mb-0">
            <thead className="bg-light text-muted">
              <tr>
                {configTypesList[params.configName]?.map((config) => {
                  return (
                    <th>
                      <h5 className="fs-13 my-1">
                        {
                          configTypes[params.configName].fields?.find(
                            (f) => f.name === config
                          )?.label
                        }
                      </h5>
                    </th>
                  );
                })}

                <th>
                  <h5 className="fs-13 my-1">Action</h5>
                </th>
              </tr>
            </thead>
            <tbody>
              {(data || [])?.map((field, key) => (
                <tr key={key}>
                  {/* <td>
                        <div className="d-flex align-items-center">
                          <div>
                            <h5 className="fs-13 my-1">{field?.configName}</h5>
                          </div>
                        </div>
                      </td> */}
                  {configTypesList[params.configName]?.map((config) => {
                    return (
                      <td>
                        {
                          field?.values.find((a) => a.fieldCode === config)
                            ?.fieldValue
                        }
                      </td>
                    );
                  })}

                  {/* <td>
                        <h5 className="fs-13 my-1 fw-normal">
                          {field?.configEnv}
                        </h5>
                      </td> */}

                  <td>
                    <Dropdown
                      isOpen={dropdownOpen[field._id]}
                      toggle={() => toggleDropdown(field._id)}
                      direction={direction}
                    >
                      <DropdownToggle className="bg-transparent border-0 p-0 shadow-none text-dark ms-auto">
                        <i className="bx bx-dots-horizontal-rounded fs-20"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          className="fs-13 d-flex align-items-center gap-1"
                          onClick={() => {
                            setEditField(field);
                            setModalOpen(true);
                          }}
                        >
                          Edit
                        </DropdownItem>
                        <DropdownItem className="fs-13 d-flex align-items-center gap-1 text-danger">
                          <AlertDelete
                            deleteHandler={() => deleteUserHandler(field?._id)}
                          />{' '}
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
    </div>
  );
};

export default Configs;
